import type { JSX } from 'react';

import { adminPath, isAdminHost } from '@/shared/config';
import { ErrorPage } from '@/shared/ui';

/**
 * Any address the table does not claim. Mounted rather than left to React
 * Router's built-in 404, which is an unstyled «Unexpected Application Error»
 * screen written for a developer.
 *
 * Outside the patient shell on purpose: an address that does not exist has no
 * tab to highlight in the tab bar, and lighting one would say the patient is
 * somewhere they are not.
 */
export function NotFoundRoute(): JSX.Element {
  return <ErrorPage homeHref={isAdminHost() ? adminPath() : '/'} kind="notFound" />;
}
